'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LargeColumn = exports.ExtraSmallColumn = exports.SmallColumn = exports.MediumColumn = exports.HalfColumn = exports.FullColumn = exports.BaseColumn = undefined;
var _templateObject = _taggedTemplateLiteral(['\n  margin: ', ';\n  padding: ', ';\n  background-color: ', ';\n  ', ';\n'], ['\n  margin: ', ';\n  padding: ', ';\n  background-color: ', ';\n  ', ';\n']),
  _templateObject2 = _taggedTemplateLiteral(['', ''], ['', '']),
  _templateObject3 = _taggedTemplateLiteral([''], ['']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _reactstrap = require('reactstrap');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var BaseColumn = exports.BaseColumn = (0, _styledComponents2.default)(_reactstrap.Col)(_templateObject, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.padding || 0;
}, function (props) {
  return props.theme[props.background || 'transparent'];
}, function (props) {
  return (0, _styledComponents.css)(_templateObject2, props.customstyle);
});
var FullColumn = exports.FullColumn = (0, _styledComponents2.default)(BaseColumn).attrs({
  xl: 12,
  lg: 12,
  md: 12,
  sm: 12,
  col: 12
})(_templateObject3);
var HalfColumn = exports.HalfColumn = (0, _styledComponents2.default)(BaseColumn).attrs({
  xl: 6,
  lg: 6,
  md: 6,
  sm: 6,
  col: 6
})(_templateObject3);
var MediumColumn = exports.MediumColumn = (0, _styledComponents2.default)(BaseColumn).attrs({
  xl: 4,
  lg: 4,
  md: 4,
  sm: 4,
  col: 4
})(_templateObject3);
var SmallColumn = exports.SmallColumn = (0, _styledComponents2.default)(BaseColumn).attrs({
  xl: 3,
  lg: 3,
  md: 3,
  sm: 3,
  col: 3
})(_templateObject3);
var ExtraSmallColumn = exports.ExtraSmallColumn = (0, _styledComponents2.default)(BaseColumn).attrs({
  xl: 2,
  lg: 2,
  md: 2,
  sm: 2,
  col: 2
})(_templateObject3);
var LargeColumn = exports.LargeColumn = (0, _styledComponents2.default)(BaseColumn).attrs({
  xl: 8,
  lg: 8,
  md: 8,
  sm: 8,
  col: 8
})(_templateObject3);